import { Banner, Button } from '@panwds/react-ui'
import { BUTTON_CONFIGURE_IDP, LABEL_CONFIGURATION_BANNER } from '../../../../constants/LabelConstants'
import type { EventHandler, VFC } from 'react'

const ConfigurationBanner: VFC<{
  onConfigureClick: EventHandler<any>
}> = ({ onConfigureClick }) => {
  return (
    <div className='tw-flex tw-bg-blue-100 tw-py-1 tw-justify-between tw-items-center tw-px-8 tw-h-full' >
      <Banner type='inline' appearance='standard' showIcon>
        {LABEL_CONFIGURATION_BANNER}
      </Banner>
      <Button appearance='primary' onClick={onConfigureClick}>{BUTTON_CONFIGURE_IDP}</Button>
    </div>
  )
}

export default ConfigurationBanner
